import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Loader';
import { useGetUserProfileQuery } from '../slices/usersApiSlices';
import { logoutUser } from '../slices/authSlice';

const PrivateRoute = () => {
  // Extracting userInfo from the Redux store
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { isLoading, isError } = useGetUserProfileQuery(undefined, {
    skip: !userInfo,
    refetchOnMountOrArgChange: true,
  });

  React.useEffect(() => {
    if (userInfo && isError) {
      dispatch(logoutUser());
    }
  }, [dispatch, isError, userInfo]);

  if (!userInfo || isError) {
    return <Navigate to="/LoginScreen" replace />;
  }

  if (isLoading) {
    return <Loader />;
  }

  // If userInfo exists/ is logged in, render the child components (Outlet)
  return <Outlet />;
};

export default PrivateRoute;
